import Button from 'tailwind-components/Button/Button';
import React from 'react';
import propTypes from 'prop-types';
import style from './ModalActionConfirmation.module.scss';
import { sanitizeDirtyHTML } from 'helpers/strings';

export default function ModalActionConfirmation({
  onPrimaryConfirm,
  onSecondaryConfirm = () => {},
  onCancel,
  primaryButtonText = '',
  secondaryButtonText = '',
  modalText = '',
  content = null,
  isDisabled = false,
  isLoading = false,
  isPrimaryButtonDisabled = false,
  isSecondaryButtonDisabled = false
}) {
  return (
    <div className={style.container}>
      {modalText && (
        <div dangerouslySetInnerHTML={sanitizeDirtyHTML(modalText)} />
      )}
      {content}
      <div className={style.buttonContainer}>
        <Button onClick={onCancel} text='Cancel' variant='danger' />
        {secondaryButtonText && (
          <Button
            onClick={() => {
              onSecondaryConfirm();
              onCancel();
            }}
            text={secondaryButtonText}
            variant='secondary'
            isDisabled={isDisabled || isLoading || isSecondaryButtonDisabled}
          />
        )}
        <Button
          isLoading={isLoading}
          isDisabled={isDisabled || isLoading || isPrimaryButtonDisabled}
          onClick={() => {
            onPrimaryConfirm();
            onCancel();
          }}
          text={primaryButtonText || 'Proceed'}
          variant='primaryDarkened'
        />
      </div>
    </div>
  );
}

ModalActionConfirmation.propTypes = {
  onPrimaryConfirm: propTypes.func.isRequired,
  onSecondaryConfirm: propTypes.func,
  onCancel: propTypes.func.isRequired,
  modalText: propTypes.string,
  content: propTypes.element,
  secondaryButtonText: propTypes.string,
  primaryButtonText: propTypes.string.isRequired,
  isDisabled: propTypes.bool,
  isLoading: propTypes.bool,
  isPrimaryButtonDisabled: propTypes.bool,
  isSecondaryButtonDisabled: propTypes.bool
};
